export const numberWithSpaces = (value: number) =>
  new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits: 0
  }).format(value)
